import Entity from "@/services/westore/entities/entity";

export class Analytics extends Entity {
  static uri = "/monthly-cod-statistics";

  static getAnalytics(params = {}) {
    return super.getAll(Analytics.uri, params);
  }
}
